// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4C52z","title":"Header_title__3d0Q7","left":"Header_left__1CxnR","clinicName":"Header_clinicName__3Yw-7"};